const initialState: Redux.Experiments = {
	assignments: {},
	configurations: {},
	gatekeeper: {},
	overrides: {},
};

export default initialState;
